
const hourFormat = new Intl.DateTimeFormat('default', {
    hour: '2-digit',
    minute: '2-digit'
})
const dayFormat = new Intl.DateTimeFormat('default', {
    weekday: 'long',
    month: '2-digit',
    day: '2-digit'
});
const fullFormat = new Intl.DateTimeFormat('default', {
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    year: "numeric"
});
export function formatHour(date){
    return hourFormat.format(date);
}
export function formatDay(date){
    return dayFormat.format(date);
}
export function formatDateTime(date){
    return fullFormat.format(date);
}